import React, { useEffect, useRef, useState } from "react";
import { logoutFunction } from "../../_helpers";
import { 
  IoLogOutOutline, 
  IoSettingsOutline,
  IoPersonOutline,
  IoHelpCircleOutline
} from "react-icons/io5";
import { MdOutlineMenu, MdOutlineNotifications, MdOutlineDashboard } from 'react-icons/md';
import { useDispatch } from "react-redux";
import { logout } from '../../Redux/userSlice';
import { useNavigate } from "react-router";
import { 
  IoIosNotificationsOutline, 
  IoIosMenu,
  IoIosLogOut,
  IoIosPerson,
  IoIosSettings,
  IoIosHelpCircle
} from "react-icons/io";
import { 
  FiMenu, 
  FiBell, 
  FiLogOut, 
  FiUser, 
  FiSettings, 
  FiHelpCircle,
  FiChevronDown,
  FiChevronUp,
  FiUserCheck
} from "react-icons/fi";
import { FaUser } from "react-icons/fa";

export default function Header({ HeaderJSON, handleNavbar }) {
  const [openModel, setOpenModel] = useState(false);
  const dispatch = useDispatch();
  const dropDownRef = useRef(null);
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState(null);

  const handleLogout = () => {
    logoutFunction();
    dispatch(logout());
  };

  const toggleLogoutModal = () => {
    setOpenModel(!openModel);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setOpenModel(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    try {
      const storedAdminData = localStorage.getItem("adminData");
      if (storedAdminData && typeof storedAdminData === "string") {
        setAdminData(JSON.parse(storedAdminData));
      }
    } catch (error) {
      console.error("Error parsing admin data from localStorage", error);
    }
  }, []);

  // Get user initials for avatar fallback
  const getUserInitials = () => {
    const name = adminData?.userName || "Admin";
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <div className="sticky top-0 z-20 flex h-16 bg-white border-b border-gray-100 shadow-sm">
      <div className="flex items-center justify-between flex-1 px-4 md:px-6">
        {/* Left Side - Menu Button */}
        <div>
          <button
            className="p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#715EFE]/30 transition-all duration-200"
            onClick={handleNavbar}
            aria-label="Toggle sidebar"
          >
            <FiMenu className="text-xl text-gray-600 sm:text-2xl" />
          </button>
        </div>

        {/* Right Side - Notifications & Profile */}
        <div className="flex items-center ml-auto space-x-3 sm:space-x-5">
          {/* Notifications */}
          {((adminData && adminData?.access?.includes("notification_management")) || (adminData && adminData?.isMain)) && (
            <button
              className="relative p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#715EFE]/30 transition-all duration-200"
              onClick={() => navigate("/app/notifications")}
              aria-label="Notifications"
            >
              <FiBell className="text-xl text-gray-600 sm:text-2xl" />
              {/* Unread badge - uncomment when needed */}
              {/* <span className="absolute top-1 right-1 flex items-center justify-center w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white animate-pulse"></span> */}
            </button>
          )}

          {/* Profile Section */}
          <div className="relative flex items-center">
            <div 
              className="flex items-center gap-2 cursor-pointer group"
              onClick={toggleLogoutModal}
            >
              {/* Avatar */}
              <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-[#855DF6] to-[#715EFE] flex items-center justify-center text-white font-semibold text-sm shadow-md hover:shadow-lg transition-all duration-200">
                {adminData?.profileImage ? (
                  <img
                    src={adminData.profileImage}
                    alt="Profile"
                    className="w-full h-full rounded-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = getUserInitials();
                    }}
                  />
                ) : (
                  <span>{getUserInitials()}</span>
                )}
              </div>

              {/* User Info */}
              <div className="flex-col justify-center hidden sm:flex">
                <h1 className="text-sm font-semibold text-gray-800 capitalize leading-tight">
                  {adminData?.userName || "Admin"}
                </h1>
                <p className="text-xs text-gray-500 capitalize">
                  {adminData?.role?.replaceAll("_", " ") || "Super Admin"}
                </p>
              </div>

              {/* Dropdown Arrow */}
              <FiChevronDown className={`hidden sm:block text-gray-400 text-sm transition-transform duration-200 ${openModel ? 'rotate-180' : ''}`} />
            </div>

            {/* Dropdown Menu */}
            {openModel && (
              <div
                className="absolute right-0 z-30 w-48 mt-2 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden top-full animate-fadeInDown"
                ref={dropDownRef}
              >
                {/* User Info in Dropdown (Mobile) */}
                <div className="px-4 py-3 border-b border-gray-100 sm:hidden">
                  <p className="text-sm font-semibold text-gray-800 capitalize">
                    {adminData?.userName || "Admin"}
                  </p>
                  <p className="text-xs text-gray-500 capitalize">
                    {adminData?.role?.replaceAll("_", " ") || "Super Admin"}
                  </p>
                </div>

                <div className="py-1">
                  {/* Profile Option */}
                  {/* <button
                    className="flex items-center w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-[#725EFE33] hover:text-[#715EFE] transition-colors duration-150 gap-3"
                    onClick={() => {
                      setOpenModel(false);
                      // navigate("/app/profile");
                    }}
                  >
                    <FiUser className="w-4 h-4" />
                    <span>Profile</span>
                  </button> */}

                  {/* Settings Option */}
                  {/* <button
                    className="flex items-center w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-[#725EFE33] hover:text-[#715EFE] transition-colors duration-150 gap-3"
                    onClick={() => {
                      setOpenModel(false);
                      // navigate("/app/settings");
                    }}
                  >
                    <FiSettings className="w-4 h-4" />
                    <span>Settings</span>
                  </button> */}

                  {/* Divider */}
                  <div className="my-1 border-t border-gray-100"></div>

                  {/* Logout Option */}
                  <button
                    onClick={handleLogout}
                    className="flex items-center w-full px-4 py-2.5 text-sm text-rose-600 hover:bg-rose-50 transition-colors duration-150 gap-3"
                  >
                    <FiLogOut className="w-4 h-4" />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add custom animation */}
      <style jsx>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInDown {
          animation: fadeInDown 0.2s ease-out;
        }
      `}</style>
    </div>
  );
}